// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"855257a1","151":"79021a4f","253":"875dd59b","275":"786348f1","294":"dd8ee8de","356":"e150c8b4","397":"572a8537","422":"17d73ce0","556":"63eb5c0a","634":"990587ca","927":"b6cf4b2f","972":"71db5779"}[chunkId] + ".chunk.css";
};